import { Layout, PageHeader, Button, Card, Form, Input, Space, Tag, Modal } from "antd";
import React, { useEffect } from "react";
import { useSystemSettings } from "../../../hooks/settings/useSystemSettings";

export const SystemSettings = () => {
  const [form] = Form.useForm();

  const { systemSettings, saving, loadSystemSettings, save, loading } = useSystemSettings();

  useEffect(() => {
    loadSystemSettings();
  }, []);

  const onAdd = (values) => {
    const { idReviewEmail } = systemSettings;

    save({
      idReviewEmail: [...idReviewEmail, values.email],
    }).then(() => {
      form.resetFields();
    });
  };

  const del = (it) => {
    Modal.confirm({
      content: "Are you sure to delete this email?",
      onOk: () => {
        const { idReviewEmail } = systemSettings;
        save({
          idReviewEmail: idReviewEmail.filter((x: string) => x.toLowerCase() !== it.toLowerCase()),
        });
      },
    });
  };

  return (
    <Layout.Content>
      <PageHeader title="System Settings"></PageHeader>
      <div className="p-24px">
        <Card
          loading={loading}
          size="small"
          title="ID Review notify emails"
          extra={
            <Button size="small" onClick={loadSystemSettings}>
              Refresh
            </Button>
          }
        >
          <Space>
            {systemSettings.idReviewEmail.map((x) => (
              <Tag
                key={x}
                closable
                onClose={(e) => {
                  e.preventDefault();
                  del(x);
                }}
              >
                {x}
              </Tag>
            ))}
          </Space>
          <Form form={form} layout="inline" onFinish={onAdd} style={{ marginTop: 20 }}>
            <Form.Item label="Email" name="email" rules={[{ required: true, type: "email" }]}>
              <Input placeholder="Enter Email" />
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={saving}
                  disabled={
                    !form.isFieldsTouched(true) || !!form.getFieldsError().filter(({ errors }) => errors.length).length
                  }
                >
                  Submit
                </Button>
              )}
            </Form.Item>
          </Form>
        </Card>
      </div>
    </Layout.Content>
  );
};
